import * as Types from 'src/actions/project/index-person-interested/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import Project from 'src/entities/Project';
import IndexResponse from 'src/value-objects/IndexResponse';
import ValidatorService from 'src/services/validation/Validation.service';

export interface IndexPersonInterestedProjectsAttempt extends Action {
  type: Types.INDEX_PERSON_INTERESTED_PROJECTS_ATTEMPT;
  payload: number;
}

export interface IndexPersonInterestedProjectsSuccess extends Action {
  type: Types.INDEX_PERSON_INTERESTED_PROJECTS_SUCCESS;
  payload: Project[];
}

export interface IndexPersonInterestedProjectsFailure extends Action {
  type: Types.INDEX_PERSON_INTERESTED_PROJECTS_FAILURE;
  payload: {};
}

export type IndexPersonInterestedProjectsAction = IndexPersonInterestedProjectsAttempt |
  IndexPersonInterestedProjectsSuccess |
  IndexPersonInterestedProjectsFailure;

export interface IndexPersonInterestedProjectsThunk
  extends ThunkAction<Promise<IndexPersonInterestedProjectsAction>, RootState, number> {
}

export const indexPersonInterestedProjectsAttempt: ActionCreator<IndexPersonInterestedProjectsAttempt> = (
  profileId: number
) => ({
  type: Types.INDEX_PERSON_INTERESTED_PROJECTS_ATTEMPT,
  payload: profileId,
});

export const indexPersonInterestedProjectsSuccess: ActionCreator<IndexPersonInterestedProjectsSuccess> = (
  projects: Project[]
) => ({
  type: Types.INDEX_PERSON_INTERESTED_PROJECTS_SUCCESS,
  payload: projects
});

export const indexPersonInterestedProjectsFailure: ActionCreator<IndexPersonInterestedProjectsFailure> = (
  error: {}
) => ({
  type: Types.INDEX_PERSON_INTERESTED_PROJECTS_FAILURE,
  payload: error
});

export const indexPersonInterestedProjects: ActionCreator<IndexPersonInterestedProjectsThunk> =
  (id: number, personType: string): IndexPersonInterestedProjectsThunk => {
    return (dispatch: Dispatch<RootState>): Promise<IndexPersonInterestedProjectsAction> => {
      dispatch(indexPersonInterestedProjectsAttempt(id));

      return ApiClient.personInterestedProjects.index({personId: id, profileType: personType})
        .then((response: AxiosResponse<IndexResponse<Project>>): IndexPersonInterestedProjectsSuccess => {
          const projects: Project[] = response.data.content;
          return dispatch(indexPersonInterestedProjectsSuccess(projects));
        }).catch((e: { response: { data: { error: {} } } }): IndexPersonInterestedProjectsFailure => {
          const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(indexPersonInterestedProjectsFailure(errorMessages));
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/index-person-interested/IndexPersonInterestedProjects.actions.tsx